import { render } from "./ReviewWidget.vue?vue&type=template&id=1d2cfefd&ts=true"
import script from "./ReviewWidget.ts?vue&type=script&lang=ts&external"
export * from "./ReviewWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__